// Swedish translations for the application
export const sv = {
  // Navigation
  navigation: {
    mergedDrivers: "Lönerapport",
    configuration: "Konfiguration",
  },

  // Actions
  actions: {
    export: "Exportera",
    filter: "Filtrera",
    merge: "Koppla Plattformar",
    clear: "Rensa",
    save: "Spara",
    cancel: "Avbryt",
    edit: "Redigera",
    delete: "Ta Bort",
    refresh: "Uppdatera",
    viewDetails: "Visa Detaljer",
    download: "Ladda Ner",
    print: "Skriv Ut",
    search: "Sök",
    addAdjustment: "Lägg Till Justering",
    removeAdjustment: "Ta Bort Justering",
    autoMatch: "Automatisk Matchning",
    unmerge: "Separera Plattformar",
  },

  // Table headers
  table: {
    name: "Namn",
    driver: "Förare",
    platform: "Plattform",
    grossEarnings: "Bruttoinkört",
    netEarnings: "Nettoinkört",
    tips: "Dricks",
    trips: "Resor",
    status: "Status",
    date: "Datum",
    amount: "Belopp",
    description: "Beskrivning",
    type: "Typ",
    total: "Totalt",
    averagePerTrip: "Genomsnitt/Resa",
  },

  // Driver related
  driver: {
    individual: "Individuella Förare",
    merged: "Multiplattform Förare",
    profile: "Förarprofil",
    earnings: "Intäkter",
    performance: "Prestanda",
    adjustments: "Justeringar",
    details: "Förardetaljer",
    history: "Historik",
    statistics: "Statistik",
    master: "Förarmaster",
    masterTitle: "Förare",
    masterDescription: "Hantera alla förare och deras plattformsalias",
    createNew: "Ny förare",
    primaryName: "Förarens namn",
    aliases: "Alias",
    contact: "Kontakt",
    personalCode: "Personnummer",
    taxiCode: "Taxikod",
    platform: "Plattform",
    aliasDetails: "Aliasdetaljer",
    addAlias: "Lägg till alias",
    deleteAlias: "Ta bort alias",
    editDriver: "Redigera förare",
    deleteDriver: "Ta bort förare",
    driverCount: "Antal förare",
    aliasCount: "Antal alias",
    averageAliases: "Genomsnittliga alias",
  },

  // Adjustments
  adjustments: {
    deduction: "Avdrag",
    compensation: "Kompensation",
    bonus: "Bonus",
    fine: "Böter",
    repairs: "Bilreparationer",
    sickLeave: "Sjuklön",
    vacation: "Semester",
    other: "Övrigt",
    manualAdjustments: "Manuella Justeringar",
    addNew: "Lägg Till Ny Justering",
    editAdjustment: "Redigera Justering",
    deleteConfirm: "Är du säker på att du vill ta bort denna justering?",
  },

  // Configuration
  config: {
    title: "Konfiguration",
    fleetSettings: "Åkeriinställningar",
    driverShare: "Förarandel (exkl. semester)",
    fleetShare: "Åkarens Andel",
    vacationPay: "Semesterersättning",
    taxRate: "Skattesats",
    vatRate: "Moms",
    saveSettings: "Spara Inställningar",
    resetDefaults: "Återställ Standardvärden",
    exampleCalculation: "Exempelberäkning",
  },

  // Status and states
  status: {
    loading: "Laddar...",
    error: "Fel",
    success: "Genomförd",
    pending: "Väntande",
    processing: "Bearbetar",
    completed: "Slutförd",
    failed: "Misslyckades",
    active: "Aktiv",
    inactive: "Inaktiv",
    merged: "Multiplattform",
    unmerged: "Enplattform",
  },

  // Messages
  messages: {
    mergeSuccess: "Plattformar har kopplats",
    mergeError: "Kunde inte koppla plattformar",
    saveSuccess: "Ändringar sparade",
    saveError: "Kunde inte spara ändringar",
    deleteSuccess: "Raderad",
    deleteError: "Kunde inte radera",
    noData: "Ingen data tillgänglig",
    selectDrivers: "Välj förare för plattformskoppling",
    confirmDelete: "Är du säker på att du vill radera?",
    dataCleared: "All data har rensats",
    settingsUpdated: "Inställningar uppdaterade",
  },
  // Periods
  periods: {
    today: "Idag",
    yesterday: "Igår",
    thisWeek: "Denna Vecka",
    lastWeek: "Förra Veckan",
    thisMonth: "Denna Månad",
    lastMonth: "Förra Månaden",
    thisYear: "Detta År",
    custom: "Anpassad Period",
  },

  // Common
  common: {
    yes: "Ja",
    no: "Nej",
    all: "Alla",
    none: "Inga",
    select: "Välj",
    selected: "Valda",
    from: "Från",
    to: "Till",
    of: "av",
    and: "och",
    or: "eller",
    per: "per",
    total: "Totalt",
    average: "Genomsnitt",
    minimum: "Minimum",
    maximum: "Maximum",
    count: "Antal",
  },
}

// Financial calculation terms
export const financialTerms = {
  grossIncome: "Bruttoinkört",
  vat: "Moms",
  netIncome: "Nettoinkört",
  netAfterVat: "Nettoinkört efter moms",
  fleetCut: "Åkaravgift",
  driverShare: "Förarandel (exkl. semester)",
  vacationPay: "Semesterersättning",
  tax: "Skatt",
  tips: "Dricks",
  totalPayout: "Total Utbetalning",
  salaryBase: "Lönegrundande",
}

// Platform names
export const platforms = {
  bolt: "Bolt",
  uber: "Uber",
  merged: "Multiplattform",
  both: "Båda",
}

// Platform brand colors
export const platformColors = {
  bolt: {
    primary: "#2a9c64", // Bolt's green
    background: "bg-[#2a9c64]",
    text: "text-white",
    border: "border-[#2a9c64]",
    hover: "hover:bg-[#228552]", // Slightly darker green for hover
    light: "bg-green-50",
    lightText: "text-green-700",
    lightBorder: "border-green-200",
  },
  uber: {
    primary: "#000000", // Uber's black
    background: "bg-black",
    text: "text-white",
    border: "border-black",
    hover: "hover:bg-gray-800", // Slightly lighter for hover
    light: "bg-gray-50",
    lightText: "text-gray-900",
    lightBorder: "border-gray-200",
  },
  merged: {
    primary: "#8b5cf6", // Purple for merged drivers
    background: "bg-purple-500",
    text: "text-white",
    border: "border-purple-500",
    hover: "hover:bg-purple-600",
    light: "bg-purple-50",
    lightText: "text-purple-700",
    lightBorder: "border-purple-200",
  },
  other: {
    primary: "#f59e0b", // Amber/Orange for other platforms
    background: "bg-amber-500",
    text: "text-white",
    border: "border-amber-500",
    hover: "hover:bg-amber-600",
    light: "bg-amber-50",
    lightText: "text-amber-700",
    lightBorder: "border-amber-200",
  },
}

// External URLs
export const externalUrls = {
  landingPage: 'https://taxiadministration.se',
  landingPageContact: 'https://taxiadministration.se/#contact',
}

// Platform styling utility function
export const getPlatformStyles = (platform: 'bolt' | 'uber' | 'merged' | 'other' | string) => {
  // Handle known platforms
  if (platform in platformColors) {
    return platformColors[platform as keyof typeof platformColors]
  }
  // Default to 'other' styling for unknown platforms
  return platformColors.other
}

// Get platform badge classes
export const getPlatformBadgeClasses = (platform: 'bolt' | 'uber' | 'merged' | 'other' | string, variant: 'solid' | 'light' = 'solid') => {
  const colors = getPlatformStyles(platform)
  
  if (variant === 'light') {
    return `${colors.light} ${colors.lightText} ${colors.lightBorder} hover:bg-opacity-80`
  }
  
  return `${colors.background} ${colors.text} ${colors.hover} border-transparent`
}